import AdministrationCustodianLayout from "../layouts/AdministrationCustodianLayout";
import { NavigationTabs } from "../components/navigation";
import {
    CustodianAccountMatchingPage,
    CustodianTransactionMatchingPage,
    HubwiseManagementPage
} from "../pages/administration";

const AdministrationCustodianRoutes = {
    path: 'custodians/*',
    pathBase: '/administration/custodians',
    defaultRoute: 'transaction-matching',
    roles: [],
    element: AdministrationCustodianLayout,
    children: [
        {
            path: 'transaction-matching',
            icon: 'right-left',
            label: 'Transaction Matches',
            roles: [],
            element: CustodianTransactionMatchingPage
        },
        {
            path: 'account-matching',
            icon: 'user-group',
            label: 'Account Matches',
            roles: [],
            element: CustodianAccountMatchingPage
        },
        {
            path: 'hubwise',
            icon: 'file-import',
            label: "Hubwise Uploads",
            roles: ["sys_admin_access"],
            element: HubwiseManagementPage
        }
    ]
};

export const AdministrationCustodianRouteTabs = () => <NavigationTabs pathBase={AdministrationCustodianRoutes.pathBase} options={AdministrationCustodianRoutes} />

export default AdministrationCustodianRoutes;